import * as React from "react"
import { cn } from "@/lib/utils"

export interface ProgressProps extends React.HTMLAttributes<HTMLDivElement> {
  value?: number
  variant?: "default" | "gradient"
}

export const Progress = React.forwardRef<HTMLDivElement, ProgressProps>(
  ({ className, value = 0, variant = "gradient", ...props }, ref) => {
    const clamped = Math.min(100, Math.max(0, value ?? 0))

    return (
      <div
        ref={ref}
        className={cn(
            "relative h-2 w-full overflow-hidden rounded-full bg-muted/70 dark:bg-muted shadow-inner ring-1 ring-border/50",
          className
        )}
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={Math.round(clamped)}
        {...props}
      >
        <div
          className={cn(
            "h-full transition-all",
            variant === "gradient"
              ? "bg-gradient-to-r from-blue-500 to-purple-500"
              : "bg-primary"
          )}
          style={{ width: `${clamped}%` }}
        />
      </div>
    )
  }
)

Progress.displayName = "Progress"
